import React from 'react';
import { withStyles, Paper, Button } from '@material-ui/core';
import { ErrorOutline, Close, Refresh } from '@material-ui/icons';
import ErrorDetailsSection from '../common/ErrorDetailsSection';
import styles from './styles';

class ComponentErrorFallback extends React.Component {
  render() {
    const { classes, error, errorInfo, errorId, onClose, onRetry, compact = false, showRefresh = true } = this.props;

    const containerClass = compact
      ? `${classes.errorContainer} ${classes.compactContainer}`
      : classes.errorContainer;
    const titleClass = compact
      ? `${classes.errorTitle} ${classes.compactTitle}`
      : classes.errorTitle;
    const descriptionClass = compact
      ? `${classes.errorDescription} ${classes.compactDescription}`
      : classes.errorDescription;

    return (
      <Paper className={containerClass} elevation={1}>
        <div className={classes.errorContent}>
          <div className={`${classes.errorHeader} ${classes.errorHeaderLeft}`}>
            <ErrorOutline className={classes.errorIcon} />
            <div className={titleClass}>Something went wrong</div>
          </div>
          <div className={descriptionClass}>
            We encountered an unexpected error while loading this section. Please try refreshing the page or continue working in other areas of the application.
          </div>
          <ErrorDetailsSection
            classes={classes}
            error={error}
            errorInfo={errorInfo}
            errorId={errorId}
            reportType="Component Error Report"
          />
        </div>
        <div className={classes.actionButton}>
          {onClose && (
            <Button
              variant="outlined"
              size="small"
              onClick={onClose}
              className={classes.closeButton}
              startIcon={<Close />}>
              Close
            </Button>
          )}
          {showRefresh && (
            <Button
              variant="outlined"
              size="small"
              onClick={onRetry}
              className={classes.retryButton}
              startIcon={<Refresh />}>
              Refresh
            </Button>
          )}
        </div>
      </Paper>
    );
  }
}

export default withStyles(styles)(ComponentErrorFallback);
